export default __webpack_public_path__ + "images/0xaaaac83751090c6ea42379626435f805ddf54dc8.png";